import { eventFactory } from './utils';

const snackBarEvent = eventFactory('snackbar');

export const clicked = (label: string): void =>
  snackBarEvent({ action: 'clicked', label });
